import { SingleLayoutData, UnitSize } from '@wix/thunderbolt-becky-types'

const getHeightInPixels = (singleLayoutData: SingleLayoutData | undefined) => {
	return singleLayoutData?.componentLayout?.height?.type === 'px'
		? (singleLayoutData?.componentLayout?.height as UnitSize)?.value
		: undefined
}

const getWidthInPixels = (singleLayoutData: SingleLayoutData | undefined) => {
	return singleLayoutData?.componentLayout?.width?.type === 'px'
		? (singleLayoutData?.componentLayout?.width as UnitSize)?.value
		: undefined
}

const isFixedPosition = (singleLayoutData: SingleLayoutData | undefined) => {
	return (
		singleLayoutData?.itemLayout?.type === 'FixedPositionItemLayout' ||
		singleLayoutData?.itemLayout?.type === 'FixedItemLayout'
	)
}

export { getHeightInPixels, getWidthInPixels, isFixedPosition }
